export const ProfileIcon = () => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.55"
      d="M38.1765 37.6135C46.7759 29.0141 46.7759 15.0718 38.1765 6.47242C29.5771 -2.12696 15.6348 -2.12696 7.03539 6.47242C-1.56399 15.0718 -1.56398 29.0141 7.03539 37.6135C15.6348 46.2129 29.5771 46.2129 38.1765 37.6135Z"
      fill="url(#paint0_linear_208_2400)"
      fillOpacity="0.45"
    />
    <path
      d="M22.6048 2.01074C11.5421 2.01074 2.573 10.9799 2.573 22.0426C2.573 33.1053 11.5421 42.0744 22.6048 42.0744C33.6675 42.0744 42.6367 33.1053 42.6367 22.0426C42.6367 10.9799 33.6675 2.01074 22.6048 2.01074ZM22.6048 37.5029C14.0666 37.5029 7.1445 30.5808 7.1445 22.0426C7.1445 13.5044 14.0666 6.58224 22.6048 6.58224C31.143 6.58224 38.0652 13.5044 38.0652 22.0426C38.0652 30.5808 31.143 37.5029 22.6048 37.5029Z"
      fill="white"
    />
    <path
      d="M22.6048 40.4015C12.4824 40.4015 4.24536 32.1669 4.24536 22.0421C4.24536 11.9172 12.4799 3.68262 22.6048 3.68262C32.7297 3.68262 40.9643 11.9172 40.9643 22.0421C40.9643 32.1669 32.7297 40.4015 22.6048 40.4015ZM22.6048 5.00485C13.2096 5.00485 5.56759 12.6493 5.56759 22.0421C5.56759 31.4348 13.2096 39.0793 22.6048 39.0793C32 39.0793 39.642 31.4348 39.642 22.0421C39.642 12.6493 31.9976 5.00485 22.6048 5.00485Z"
      fill="url(#paint1_linear_208_2400)"
    />
    <path
      d="M36.0315 25.6198C38.0074 18.2042 33.5977 10.5908 26.182 8.61489C18.7664 6.63897 11.153 11.0487 9.17709 18.4644C7.20117 25.88 11.6109 33.4934 19.0266 35.4693C26.4422 37.4452 34.0556 33.0355 36.0315 25.6198Z"
      fill="url(#paint2_linear_208_2400)"
    />
    <path
      d="M27.4385 17.0444C27.4385 14.375 25.2744 12.2109 22.605 12.2109C19.9355 12.2109 17.7715 14.375 17.7715 17.0444C17.7715 19.7139 19.9355 21.8779 22.605 21.8779C25.2744 21.8779 27.4385 19.7139 27.4385 17.0444Z"
      fill="white"
    />
    <path
      d="M25.996 23.0439H19.2134C17.3256 23.0439 15.7805 24.589 15.7805 26.4769V34.1458C17.7957 35.2844 20.1243 35.9382 22.6047 35.9382C25.0851 35.9382 27.4137 35.2844 29.4289 34.1458V26.4769C29.4289 24.589 27.8838 23.0439 25.996 23.0439Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_208_2400"
        x1="6.78593"
        y1="37.3641"
        x2="38.0701"
        y2="6.12264"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_208_2400"
        x1="4.24536"
        y1="21.7479"
        x2="41.1077"
        y2="21.7731"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_208_2400"
        x1="18.8115"
        y1="35.412"
        x2="26.0133"
        y2="8.45756"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
    </defs>
  </svg>
);
